module.exports = __webpack_public_path__ + "img/金属材料学3_2.8780d0e7.png";